import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { convertDateToUTCEpoch, convertDateToUTC } from '../../../Helper/date'
import InputField from '../../../commonComponents/formComponents/inputField'
import DropDown from '../../../commonComponents/formComponents/dropDown'
import { Form, Grid } from 'semantic-ui-react'
import { TranslateContext } from '../TranslateContext'
import PopUpIcon from '../../../commonComponents/formComponents/PopUpIcon'
import { UPDATE_EXCHANGE_RATE_AND_EUR_VAL } from '../../actions/actionTypes'

const InvoiceForm = (props) => {

    const dispatch = useDispatch()
    const { invoiceItemIndex, invoiceId, updateData, saveData,fieldPattern, validateError } = props
    const { invoice } = fieldPattern
    const invoiceNum = useSelector((state) => state.InvoicesReducer.invoices[invoiceItemIndex]?.invoiceNum) || ''
    const invoiceEpoch = useSelector((state) => state.InvoicesReducer.invoices[invoiceItemIndex]?.invoiceEpoch) || ''
    const poNumber = useSelector((state) => state.InvoicesReducer.invoices[invoiceItemIndex]?.poNumber) || ''
    const shipmentId = useSelector((state) => state.InvoicesReducer.invoices[invoiceItemIndex]?.shipmentId) || ''
    const invTotalAmt = useSelector((state) => state.InvoicesReducer.invoices[invoiceItemIndex]?.invTotalAmt) || ''
    const grossWeightQty = useSelector((state) => state.InvoicesReducer.invoices[invoiceItemIndex]?.grossWeightQty) || ''
    const netWeightQty = useSelector((state) => state.InvoicesReducer.invoices[invoiceItemIndex]?.netWeightQty) || ''

    const pkgQty = useSelector((state) => state.InvoicesReducer.invoices[invoiceItemIndex]?.pkgQty) || ''
    const currencyCode = useSelector((state) => state.InvoicesReducer.invoices[invoiceItemIndex]?.currencyCode) || ''
    const exchRate = useSelector((state) => state.InvoicesReducer.invoices[invoiceItemIndex]?.exchRate) || ''
    const currencyList = useSelector((state) => state.DropDownValues?.currencyCodes) || []

    const translate = React.useContext(TranslateContext).translate      

    const invoiceNumErr = useSelector((state)=>state?.ValidationErrors.items?.[`invoice${invoiceItemIndex+1}_invoiceNum`]) 
    const poNumberErr = useSelector((state)=>state?.ValidationErrors.items?.[`invoice${invoiceItemIndex+1}_poNumber`]) 
    const invoiceEpochErr = useSelector((state)=>state?.ValidationErrors.items?.[`invoice${invoiceItemIndex+1}_invoiceEpoch`]) 
    const currencyCodeErr = useSelector((state)=>state?.ValidationErrors.items?.[`invoice${invoiceItemIndex+1}_currencyCode`]) 
    const exchRateErr = useSelector((state)=>state?.ValidationErrors.items?.[`invoice${invoiceItemIndex+1}_exchRate`]) 

    const saveCurrencyCode = async(params) => {
        const response = await saveData(params)
        const exchangeRate = response?.invoices?.[0]?.exchRate || 0
        updateData({ exchRate: exchangeRate })
        const key = `invoice${invoiceItemIndex+1}_exchRate`
        validateError(
            {[key]:""},
            {[key]:exchangeRate},
            {[key]:invoice(invoiceItemIndex+1)?.exchRate}
        )
        saveExchRate({ exchRate: exchangeRate })
    }

    const saveExchRate = async(params) => {        
        const response = await saveData(params)
        dispatch({
            type:UPDATE_EXCHANGE_RATE_AND_EUR_VAL,
            payload:response
        })
    }

    useEffect(() => {
        if (currencyCode && !parseFloat(exchRate)) {
            saveCurrencyCode({ currencyCode: currencyCode })
        }
    }, [])

    return (
        <React.Fragment>
            <Form.Group className='float-container' widths='equal'>
                <Grid className='kn__grid'>
                    <Grid.Row>
                        <Grid.Column width='4' className='divFormFeild b-bw-1'>
                            <InputField
                                isLabel={false}
                                id={`invoiceNum-${invoiceId}`}
                                type='text'
                                label={translate('INVOICE_NUMBER', { ns: ['default', 'lineItem'] })}
                                value={invoiceNum}
                                className={'field-bg'}
                                clearInput={false}  
                                errors={invoiceNumErr && invoiceNumErr?.msg}
                                onChange={(value) => {
                                    updateData({ invoiceNum: value })
                                }}
                                onBlur={(value) => {
                                    saveData({ invoiceNum: value })
                                    const key = `invoice${invoiceItemIndex+1}_invoiceNum`
                                    validateError(
                                        {[key]:""},
                                        {[key]:value},
                                        {[key]:invoice(invoiceItemIndex+1)?.invoiceNum}
                                    )
                                }}
                            />
                        </Grid.Column>
                        <Grid.Column width='3' className='divFormFeild datepicker1  b-bw-1 '>
                            <InputField
                                isLabel={false}
                                id={`invoiceEpoch-${invoiceId}`}
                                type='date'
                                label={
                                    <div className='nl-date__label'>
                                         {invoiceEpochErr  &&
                                            <PopUpIcon className="nl-date__label-error"
                                                color="red" icon="exclamation triangle circle"
                                                popupText={invoiceEpochErr?.msg} />
                                        }
                                        {translate('INVOICE_DATE', { ns: ['default', 'lineItem'] })}
                                    </div>                                    
                                }
                                className='field-bg'
                                value={convertDateToUTC(invoiceEpoch)}
                                // errors={invoiceEpochErr&&invoiceEpochErr?.msg}
                                clearInput={false}
                                onChange={(value) => {
                                    value = convertDateToUTCEpoch(value)
                                    updateData({ invoiceEpoch: value })
                                    saveData({ invoiceEpoch: value })
                                    const key =`invoice${invoiceItemIndex+1}_invoiceEpoch`
                                    validateError({[key]:""},{[key]:value},
                                        {[key]:invoice(invoiceItemIndex+1)?.invoiceEpoch}
                                    )
                                }}
                            />
                        </Grid.Column>
                        <Grid.Column width='3' className='divFormFeild'>
                            <InputField
                                isLabel={false}
                                id={`shipmentId--${invoiceId}`}
                                type='text'
                                label={translate('SHIPMENT_ID', { ns: ['default', 'lineItem'] })}
                                value={shipmentId}
                                className={'field-bg'}
                                clearInput={false}
                                disabled={true}
                                onChange={(value) => {
                                  // dispatch(updateInvoiceLineItemFeild(invoiceId, 'poNo', value))
                                }}
                                onBlur={(value) => {
                                    // dispatch(saveInvoiceLineItemFeild(invoiceId, 'poNo'))
                                }}
                            />
                        </Grid.Column>
                        <Grid.Column width='3' className='divFormFeild  b-bw-1'>
                            <InputField
                                isLabel={false}
                                id={`poNumber--${invoiceId}`}
                                type='text'
                                label={translate('PO_NUM', { ns: ['default', 'lineItem'] })}
                                value={poNumber}
                                className={'field-bg'}
                                clearInput={false} 
                                errors={poNumberErr && poNumberErr?.msg}
                                onChange={(value) => {
                                    updateData({ poNumber: value })
                                }}
                                onBlur={(value) => {
                                    saveData({ poNumber: value || " " })  
                                    const key = `invoice${invoiceItemIndex+1}_poNumber`
                                    validateError({[key]:""}, {[key]:value},
                                        {[key]:invoice(invoiceItemIndex+1)?.poNumber}
                                    )                                 
                                }}
                            />
                        </Grid.Column>
                        <Grid.Column width='3' className='divFormFeild'>
                            <InputField
                                isLabel={false}
                                id={`invTotalAmt-${invoiceId}`}
                                type='number'
                                label={translate('INV_TOT_VALUE', { ns: ['default', 'lineItem'] })}
                                value={invTotalAmt}
                                className={'field-bg'}
                                clearInput={false}
                                disabled={true}
                                onChange={(value) => {
                                    updateData({ invTotalAmt: value })
                                }}
                                // onBlur={(value) => {
                                //     saveData({ invTotalAmt: value })
                                // }}
                            />
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width='3' className='divFormFeild'>
                            <InputField
                                isLabel={false}
                                id={`grossWeightQty-${invoiceId}`}
                                type='text'
                                label={translate('GROSS_WEIGHT', { ns: ['default', 'lineItem'] })}
                                value={grossWeightQty}
                                className={'field-bg'}
                                clearInput={false}
                                disabled={true}
                                onChange={(value) => {
                                    updateData({ grossWeightQty: value })
                                }}
                                // onBlur={(value) => {
                                //     saveData({ grossWeightQty: value })
                                // }}
                            />
                        </Grid.Column>

                        <Grid.Column width='3' className='divFormFeild'>
                            <InputField
                                isLabel={false}
                                id={`netWeightQty-${invoiceId}`}
                                type='text'
                                label={translate('NET_WEIGHT', { ns: ['default', 'lineItem'] })}
                                value={netWeightQty}
                                className={'field-bg'}
                                clearInput={false}
                                disabled={true}
                                onChange={(value) => {
                                    updateData({ netWeightQty: value })
                                }}
                                // onBlur={(value) => {
                                //     saveData({ netWeightQty: value })
                                // }}
                            />
                        </Grid.Column>
                    {/* </Grid.Row>
                    <Grid.Row> */}
                    <Grid.Column width='3' className='divFormFeild'>
                            <InputField
                                isLabel={false}
                                id={`pkgQty-${invoiceId}`}
                                type='text'
                                label={translate('PACKAGE_QTY', { ns: ['default', 'lineItem'] })}
                                value={pkgQty}
                                className={'field-bg'}
                                clearInput={false}
                                disabled={true}
                                onChange={(value) => {
                                    updateData({ pkgQty: value })
                                }}
                                // onBlur={(value) => {
                                //     saveData({ pkgQty: value || " " })
                                // }}
                            />
                        </Grid.Column>
                        {/* <Grid.Column width='4' className='divFormFeild '>
                            <AddDropdown
                                id={`pkgType-${invoiceId}`}
                                type='packageTypes'
                                label={translate('PKG_TYPE', { ns: ['default', 'lineItem'] })}
                                onSelect={({ value }) => {
                                    updateData({ pkgType: value })
                                }}
                                onBlur={({ value }) => {
                                    if (!value?.trim()) {
                                        saveData({ pkgType: value || " " })
                                    }
                                }}
                                selectedValue={pkgType}
                            />
                        </Grid.Column> */}
                        <Grid.Column width='4' className='divFormFeild'>
                            <DropDown
                                id={`currencyCode-${invoiceId}`}
                                label={translate('CURRENCY_CODE', { ns: ['default', 'lineItem'] })}
                                className='field-bg dropdown100'
                                labelClass='text-none'
                                isLabel={true}
                                data={currencyList}
                                value={currencyCode}
                                errors={currencyCodeErr && currencyCodeErr?.msg}
                                onChange={(value) => {
                                    updateData({ currencyCode: value })
                                    const key = `invoice${invoiceItemIndex+1}_currencyCode`
                                    validateError(
                                        {[key]:""},
                                        {[key]:value},
                                        {[key]:invoice(invoiceItemIndex+1)?.currencyCode}
                                    )
                                    saveCurrencyCode({ currencyCode: value })
                                    // saveData({ currencyCode: value })
                                }}
                            />
                        </Grid.Column>
                        <Grid.Column width='3' className='divFormFeild'>
                            <InputField
                                isLabel={false}
                                id={`exchRate-${invoiceId}`}
                                type='text'
                                label={translate('EXCHANGE_RATE', {
                                    ns: ['default', 'lineItem', 'valueBuildUp'],
                                })}
                                value={exchRate}
                                className={'field-bg'}
                                clearInput={false}
                                errors={exchRateErr&&exchRateErr?.msg}
                                onChange={(value) => {
                                    updateData({ exchRate: value })
                                }}
                                onBlur={(value) => {
                                    const key = `invoice${invoiceItemIndex+1}_exchRate`
                                    validateError(
                                        {[key]:""},
                                        {[key]:value},
                                        {[key]:invoice(invoiceItemIndex+1)?.exchRate}
                                    )
                                    saveExchRate({ exchRate: value })
                                }}
                            />
                        </Grid.Column>
                    </Grid.Row>

                </Grid>
            </Form.Group>
        </React.Fragment>
    )
}

export default InvoiceForm